import { BSBuildingResult } from "../../dto/beem-shot/BSBuildingResult/BSBuildingResult"

export function computeLabelIsRE2020(bsBuildingResult: BSBuildingResult): string {
  if (bsBuildingResult.carbonImpactTotalPerSurface < bsBuildingResult.threshold2031) {
    return "Seuil 2031"
  } else if (bsBuildingResult.carbonImpactTotalPerSurface < bsBuildingResult.threshold2028) {
    return "Seuil 2028"
  } else if (bsBuildingResult.carbonImpactTotalPerSurface < bsBuildingResult.threshold2025) {
    return "Seuil 2025"
  } else if (bsBuildingResult.carbonImpactTotalPerSurface < bsBuildingResult.threshold2022) {
    return "Seuil 2022"
  } else {
    return "Non RE2020"
  }
}
